import { DividendFrequency } from '../../../hooks/dividend/dividend.types';

const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const formatDividendPeriod = (
  frequency: DividendFrequency,
  year: number,
  periodIndex: null | number,
): string => {
  if (frequency === DividendFrequency.ANNUALLY) return `Annual ${year}`;
  if (frequency === DividendFrequency.QUARTERLY) return `Q${periodIndex ?? ''} ${year}`;
  if (frequency === DividendFrequency.SEMI_ANNUALLY) return `H${periodIndex ?? ''} ${year}`;
  if (frequency === DividendFrequency.MONTHLY && periodIndex)
    return `${MONTH_NAMES[periodIndex - 1]} ${year}`;
  return String(year);
};
